import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import ClimaCheckService from '~/api/services/climaCheck'
import { FormFields } from '~/components/FormFields'
import Layout from '~/components/Layout'
import notify from '~/components/Notify'
import { handleErrors } from '~/utils/helpers'

const KPM:React.FC = () => {
  const { t } = useTranslation()
  
  const [isBusy, setIsBusy] = useState(false)

  const { control, handleSubmit, reset } = useForm({
    mode: 'onSubmit'
  })

  useEffect(() => {
    fetchData()
  }, [])

  async function fetchData() {
    setIsBusy(true)
    try {
      const response = await ClimaCheckService.getClimaCheckSettings()
      reset(response.data)
    } catch(error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  function renderForm() {
    return <div style={{ padding: 20 }}>
      <FormFields.Checkbox
        control={control}
        name='useMilkPrice'
        defaultValue={0}
        checkboxValue={1}
        label={t('Display milk price')}
      />
      <FormFields.Checkbox
        control={control}
        name='applyForageProductionInDataCollection'
        defaultValue={0}
        checkboxValue={1}
        label={t('Apply forage production in the context of data collection?')}
      />
    </div>
  }

  async function onSubmit(data) {
    setIsBusy(true)
    try {
      await ClimaCheckService.updateClimaCheckSettings(data)
      notify(t('Successfully update Clima check settings'), 'success')
    } catch(error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  return <Layout
    title={'KPM'}
    isBusy={isBusy}
    segmented
    onSubmit={handleSubmit(onSubmit)}
    action={t('Update')}
  >
    {renderForm()}
  </Layout>
}
export default KPM